"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requete = requete;
exports.requetePost = requetePost;
exports.requeteGerer = requeteGerer;
exports.afficherDialogueAuthentication = afficherDialogueAuthentication;

var _utilitaires = require("./utilitaires");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function requete(_x, _x2, _x3) {
  return _requete.apply(this, arguments);
}

function _requete() {
  _requete = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(adresse, contexte, optionsInitiales) {
    var options, headers;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            options = {};

            if ((0, _utilitaires.estDefini)(optionsInitiales)) {
              Object.assign(options, optionsInitiales);
            }

            if ((0, _utilitaires.estDefini)(contexte) && (0, _utilitaires.nestPasNulOuVide)(contexte.contexteSAI)) {
              headers = options.headers;

              if (!(0, _utilitaires.estDefini)(headers)) {
                options.headers = headers = {};
              }

              headers.Authentication = contexte.contexteSAI;
            }

            return _context.abrupt("return", fetch(adresse, options));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _requete.apply(this, arguments);
}

function requetePost(_x4, _x5, _x6, _x7) {
  return _requetePost.apply(this, arguments);
}

function _requetePost() {
  _requetePost = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(adresse, contexte, corps, optionsInitiales) {
    var options;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            options = {
              method: 'POST',
              headers: {
                'Accept': 'application/json, text/plain',
                'Content-Type': 'application/json;charset=UTF-8'
              }
            };

            if ((0, _utilitaires.estDefini)(corps)) {
              options.body = JSON.stringify(corps);
            }

            if ((0, _utilitaires.estDefini)(optionsInitiales)) {
              Object.assign(options, optionsInitiales);
            }

            return _context2.abrupt("return", requete(adresse, contexte, options));

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _requetePost.apply(this, arguments);
}

function requeteGerer(_x8, _x9, _x10, _x11, _x12, _x13) {
  return _requeteGerer.apply(this, arguments);
}

function _requeteGerer() {
  _requeteGerer = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(adresse, callbackRequeteEchoue, callbackObjetEchoue, contexteSAI, typeReponse, options) {
    var reponse, adresseReponse, objet;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            reponse = null;
            adresseReponse = "".concat(adresse).concat((0, _utilitaires.estDefini)(contexteSAI) ? "?contexteSAI=".concat(contexteSAI) : '');
            typeReponse = (0, _utilitaires.estDefini)(typeReponse) ? typeReponse : 'json';
            _context3.prev = 3;
            _context3.next = 6;
            return fetch(adresseReponse, options);

          case 6:
            reponse = _context3.sent;

            if (!(reponse.status !== 200)) {
              _context3.next = 10;
              break;
            }

            callbackRequeteEchoue(reponse.status, null);
            return _context3.abrupt("return", null);

          case 10:
            _context3.next = 16;
            break;

          case 12:
            _context3.prev = 12;
            _context3.t0 = _context3["catch"](3);
            callbackRequeteEchoue(null, _context3.t0);
            return _context3.abrupt("return");

          case 16:
            objet = null;
            _context3.prev = 17;
            _context3.next = 20;
            return reponse[typeReponse]();

          case 20:
            objet = _context3.sent;
            return _context3.abrupt("return", objet);

          case 24:
            _context3.prev = 24;
            _context3.t1 = _context3["catch"](17);
            callbackObjetEchoue(_context3.t1);
            return _context3.abrupt("return", null);

          case 28:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[3, 12], [17, 24]]);
  }));
  return _requeteGerer.apply(this, arguments);
}

function afficherDialogueAuthentication(resultat, contexte) {
  if (!(0, _utilitaires.estDefini)(contexte)) {
    return false;
  }

  var environnement = contexte.environnement,
      afficherDialogueAuthentication = contexte.afficherDialogueAuthentication;

  if (environnement !== 'Extranet') {
    return false;
  } else if (!(0, _utilitaires.estDefini)(resultat) || resultat.status === 401) {
    if (!(0, _utilitaires.estDefini)(afficherDialogueAuthentication) || typeof afficherDialogueAuthentication !== 'function') {
      console.log(resultat);
      return false;
    }

    afficherDialogueAuthentication();
    return true;
  }

  return false;
}